const data = {
  "events": [
    {
      "start_date": {"year": 1907},
      "text": {"headline": "Hitler refusé à l'École des Beaux-Arts", "text": "Adolf Hitler est refusé deux fois à l’Académie des Beaux-Arts de Vienne. Il n'est pas mauvais dessinateur, mais ne travaille pas assez et est incapable de se soumettre à une discipline."},
      "media": {"url": "assets/images/peinture1.webp", "caption": "Der Alte Hof in München, aquarelle, 1914"}
    },
    {
      "start_date": {"year": 1914, "month": 8, "day": 5},
      "text": {"headline": "Première Guerre mondiale", "text": "Hitler s’engage volontairement dans l’armée allemande le 5 août 1914. Il est définitivement incorporé le 16 août comme « volontaire » dans le 1er bataillon du 2e régiment d'infanterie de l'armée bavaroise."},
      "media": {"url": "assets/images/ww1.webp", "caption": "Adolf Hitler, assis à droite, en 1915"}
    },


    {
      "start_date": {"year": 1929, "month": 6, "day": 12},
      "text": {"headline": "Naissance d'Anne Frank", "text": "Anne (Anneliese Marie) Frank, fille d'Otto et Edith Frank, naît à Francfort. Sa sœur Margot est de trois ans son aînée. L’Allemagne est alors en crise : il y a peu de travail et beaucoup de pauvreté. Adolf Hitler et son parti nazi ont de plus en plus d’adeptes."},
      "media": {"url": "assets/images/anne-frank1.webp", "caption": "Portrait d'Anne Frank, en 1935"}
    },

    


    {
      "start_date": {"year": 1933, "month": 1, "day": 30},
      "text": {"headline": "Hitler devient chancelier", "text": "Le Parti nazi, prend le contrôle de l'État allemand quand le président Paul von Hindenburg nomme son chef, ou Führer, Adolf Hitler, chancelier. Celui-ci s'empare alors des rênes d'un gouvernement de coalition au service d'un « Renouveau national »."},
      "media": {"url": "assets/images/chancelier.webp", "caption": "Adolf Hitler applaudi alors qu’il quitte l’Hôtel Kaiserhof peu après son investiture en tant que chancelier."}
    },
    {
      "start_date": {"year": 1933, "month": 2, "day": 27},
      "text": {"headline": "Incendie du Reichstag", "text": "Un incendie criminel ravage le parlement allemand (Reichstag). Le gouvernement rejette la faute, à tort, sur les communistes, qui mettraient tout en œuvre pour renverser l'État."},
      "media": {"url": "assets/images/incendie.webp", "caption": "Le bâtiment du Reichstag détruit, après l'incendie"}
    },
    {
      "start_date": {"year": 1933, "month": 3, "day":22},
      "text": {"headline": "Ouverture du camp de Dachau", "text": "La SS (de Schutzstaffel, escadrons de protection) met en place le premier camp de concentration à côté de la ville de Dachau, en Allemagne. Elle y emprisonne les opposants politiques au régime. Dachau sera le seul camp de concentration à rester actif de 1933 à 1945."},
      "media": {"url": "assets/images/dachau.webp", "caption": "Vue aérienne du camp de Dachau"}
    },
    {
      "start_date": {"year": 1933, "month": 3, "day":23},
      "text": {"headline": "L'Allemagne sous dictature", "text": "Le parlement allemand passe la Loi sur la suppression de la misère du peuple et du Reich (Gesetz zur Behebung der Not von Volk und Reich), connue sous le nom de Loi des pleins pouvoirs (Ermächtigungsgesetz). Elle permet à Hitler d'adopter de nouvelles lois sans le consentement du parlement, instaurant de fait une dictature en Allemagne."},
      "media": {"url": "assets/images/plein-pouvoir.webp", "caption": "Le discours d'Adolf Hitler au Reichstag le 23 mars 1933 qui annonce la loi des pleins pouvoirs."}
    },
    {
      "start_date": {"year": 1933, "month": 4, "day":1},
      "text": {"headline": "Boycott des commerces Juifs", "text": "Des membres du Parti nazi et ses organisations annexes (comme la SS, la SA ou les Jeunesses hitlériennes) appellent au boycott des commerces juifs dans tout le pays."},
      "media": {"url": "assets/images/boycott.webp", "caption": "Joseph Goebbels, ministre nazi de la propagande, appelle au boycott des commerces juifs"}
    },
    {
      "start_date": {"year": 1933, "month": 4, "day":7},
      "text": {"headline": "Loi excluant les Juifs", "text": "Le gouvernement allemand promulgue une loi de réforme de la fonction publique (Gesetz zur Wiederherstellung des Berufsbeamtentums) qui exclut les Juifs et les opposants politiques de tout poste de fonctionnaire. Dans un premier temps sont exemptées les personnes en poste depuis le 1er août 1914, les anciens combattants de la Première Guerre mondiale, et ceux dont le père ou le fils a été tué au combat au cours de ce conflit."},
      "media": {"url": "assets/images/lois-machin.webp", "caption": "Première page de la loi Gesetz zur Wiederherstellung des Berufsbeamtentums"}
    },
    {
      "start_date": {"year": 1933, "month": 4, "day":11},
      "text": {"headline": "Classification des Juifs", "text": "Le gouvernement allemand promulgue un décret obligeant les fonctionnaires en poste depuis le 1er août 1914 et après à prouver leur ascendance « aryenne » ou leur statut d'ancien combattant de la Première Guerre mondiale. Une classification définit qui est considéré comme Juif et « non aryen » : toute personne avec au moins l'un des parents ou grands-parents « non aryens » est elle-même « non-Aryenne »."},
      "media": {"url": "assets/images/aryen.webp", "caption": "Des bébés Polonais, sélectionnés pour leurs traits « Aryens », pour être adoptés et élevés en tant qu'Allemands ethniques"}
    },
    {
      "start_date": {"year": 1933, "month": 4, "day":26},
      "text": {"headline": "Création de la Gestapo", "text": "Hermann Goering, ministre-président et ministre de l'Intérieur de Prusse, l'État allemand le plus grand, crée une nouvelle institution, la Gestapo (Geheime Staatspolizei ou Police secrète d'État) à partir de l'ancien département de la police politique prussien."},
      "media": {"url": "assets/images/gestapo.webp", "caption": "Agents de la Gestapo en costume civil"}
    },
    {
      "start_date": {"year": 1933, "month": 5, "day":7},
      "text": {"headline": "Renvoie de centaines de Juifs", "text": "Le gouvernement allemand décrète que tous les travailleurs et employés juifs dans les forces armées allemandes (Reichswehr) doivent être renvoyés."},
      "media": {"url": "assets/images/boycott2.webp", "caption": "Propagande allemande, montrant que le magasin appartient à l'Allemagne"}
    },
    {
      "start_date": {"year": 1933, "month": 5, "day":10},
      "text": {"headline": "« Purification »", "text": "Des organisations étudiantes allemandes soutenues par des membres du Parti nazi participent à des manifestations à travers tout le pays. Ils brûlent des livres dont les auteurs sont des Juifs, des opposants politiques ou des intellectuels libéraux, et annoncent la « purification » des bibliothèques allemandes qu'ils vident de leurs ouvrages « non allemands »."},
      "media": {"url": "assets/images/brule.webp", "caption": "Des allemands se rassemblent pour l'autodafé de livres jugés « antiallemands »"}
    },
    {
      "start_date": {"year": 1933, "month": 7, "day":14},
      "text": {"headline": "Loi contre les maladies héréditaires", "text": "Une autre loi concernant la transmission de maladies héréditaires (Gesetz zur Verhütung erbkranken Nachwuchses) rend obligatoire la stérilisation de certains handicapés physiques et mentaux. C'est à partir de cette législation que des opérations chirurgicales sont effectuées contre la volonté des individus, non seulement des personnes handicapées, mais aussi des Tsiganes, des « éléments asociaux » et des Afro-Allemands."},
      "media": {"url": "assets/images/maladies.webp", "caption": "Document portant sur les maladies héréditaires, écrit le 12/07/1933"}
    },
    {
      "start_date": {"year": 1933, "month": 8},
      "text": {"headline": "La famille Frank fuit", "text": "La famille Frank décide de fuir l'Allemagne nazie : Otto part à Amsterdam ; Edith, Anne et Margot se réfugient à Aix la Chapelle, chez Rosa, la grand-mère Holländer."},
      "media": {"url": "assets/images/familleanne.webp", "caption": "La famille d'Anne Frank"}
    },
    {
      "start_date": {"year": 1933, "month": 9, "day":2},
      "text": {"headline": "Exclusion des Juifs du monde culturel", "text": "En Allemagne, peu après la création de Chambres pour la littérature, la presse, la radio, le théâtre, le cinéma, la musique et les beaux-arts, les Juifs se voient interdits d'en devenir membres. Ceci les exclut de fait de tout emploi dans le secteur culturel."},
      "media": {"url": "assets/images/boycott3.webp", "caption": "Des allemands avec des pancartes interdisant d'acheter chez les Juifs"}
    },



    {
      "start_date": {"year": 1934, "month": 2},
      "text": {"headline": "Anne Frank à Amsterdam", "text": "Anne Frank rejoint sa famille à Amsterdam."},
      "media": {"url": "assets/images/margotaf.webp", "caption": "Les soeurs Frank avant d'arriver à Amsterdam"}
    },
    {
      "start_date": {"year": 1934, "month": 6, "day":30},
      "text": {"headline": "Nuit des Longs Couteaux", "text": "Dans « l'affaire Röhm », plus connue sous le nom de « Nuit des longs couteaux », a eu lieu du 30 juin au 2 juillet 1934 en Allemagne, une purge politique organisée par Adolf Hitler. Il a fait éliminer des membres des SA (les sections d’assaut) et d’autres opposants pour consolider son pouvoir et rassurer l’armée. Cette opération a marqué un tournant dans la montée du régime nazi vers une dictature totale."},
      "media": {"url": "assets/images/troupessa.webp", "caption": "Des troupes de la SA"}
    },
    {
      "start_date": {"year": 1934, "month": 8, "day":19},
      "text": {"headline": "Hitler s'autoproclame Führer du Reich", "text": "Hitler abolit la fonction de président et s'autoproclame Führer du Reich et du peuple allemand, tout en restant chancelier. Il peut désormais prendre des décisions sans tenir compte des lois ni de l'État, ce qui fait de lui le dictateur absolu du pays, dont l'autorité n'est limitée par aucun système juridique ou constitutionnel."},
      "media": {"url": "assets/images/loireich.webp", "caption": "Loi sur le chef d'État du Reich allemand, dont le plébiscite a été demandé le 19/08"}
    },
    {
      "start_date": {"year": 1934, "month": 12, "day":10},
      "text": {"headline": "Inspection des camps", "text": "Himmler fonde l'Inspection des camps de concentration et place le général Theodor Eicke à sa tête. Cette initiative officialise la prise de pouvoir SS et centralise le système concentrationnaire installé en juillet 1934."},
      "media": {"url": "assets/images/eicke.webp", "caption": "Theodor Eicke en tenue de SS"}
    },




    {
      "start_date": {"year": 1935, "month": 9, "day":15},
      "text": {"headline": "Lois de Nuremberg", "text": "Le gouvernement allemand décrète les lois raciales dites « de Nuremberg », notamment celle relative à la citoyenneté du Reich et celle « pour la protection du sang et de l'honneur allemand ». C'est Hitler qui annonce ces nouvelles mesures lors du rassemblement du Parti nazi à Nuremberg. Les Juifs deviennent de fait des citoyens de seconde zone. Ces lois interdisent le mariage mixte et criminalisent les relations sexuelles entre Juifs et « personnes de sang allemand ou apparenté ». Le gouvernement les appliquera ensuite aux Tsiganes et aux Afro-Allemands."},
      "media": {"url": "assets/images/loisnuremberg.webp", "caption": "Document schématisant la loi de Nuremberg"}
    },





    {
      "start_date": {"year": 1936, "month": 7, "day": 12},
      "text": {"headline": "Camp de concentration de Sachsenhausen", "text": "La SS met en place le camp de concentration de Sachsenhausen, près d'Oranienburg, au nord de Berlin. En septembre, les autorités allemandes y auront incarcéré environ 1000 personnes."},
      "media": {"url": "assets/images/sachsenhausen.webp", "caption": "Vue aérienne du camp, prise en 1943"}
    },
    {
      "start_date": {"year": 1936, "month": 7, "day": 16},
      "text": {"headline": "Camp Marzahn", "text": "Les autorités allemandes ordonnent l'arrestation et le transfert de tous les Tsiganes de Berlin et ses environs vers un camp en banlieue de la ville, Marzahn. C'est de là que, à partir de 1938, ils seront déportés vers d'autres camps de concentration."},
      "media": {"url": "assets/images/marzahn.webp", "caption": "Le camp d'internement de Marzahn"}
    },
    {
      "start_date": {"year": 1936, "month": 11, "day": 25},
      "text": {"headline": "Pacte anti-Komintern", "text": "L’Allemagne nazie, représentée par Joachim von Ribbentrop, et le Japon impérial, représenté par l'ambassadeur du Japon Kintomo Mushanokōji,signent le pacte anti-Komintern, dirigé contre l’Union soviétique et le mouvement communiste international."},
      "media": {"url": "assets/images/antikomintern.webp", "caption": "L'ambassadeur du Japon en Allemagne, et l'ambassadeur itinérant d'Allemagne, signent le pacte anti-Komintern."}
    },






    {
      "start_date": {"year": 1937, "month": 2, "day": 27},
      "text": {"headline": "Première rafle d'emprisonnement", "text": "La police criminelle allemande emprisonne, entre le 27 février et le 9 mars, environ 2000 condamnés pour délinquance en camp de concentration. C'est la première rafle à une telle échelle concernant des personnes autres que des opposants politiques."},
      "media": {"url": "assets/images/rafle.webp", "caption": "Des juifs se font arrêtés par la police allemande"}
    },
    {
      "start_date": {"year": 1937, "month": 7, "day": 7},
      "text": {"headline": "Le Japon envahit la Chine.", "text": "Le Japon envahit la Chine."},
      "media": {"url": "assets/images/japonchine.webp", "caption": "Soldats japonais avançant dans les ruines de Shanghai en 1937"}
    },
    {
      "start_date": {"year": 1937, "month": 7, "day": 15},
      "text": {"headline": "Complexe de Buchenwald", "text": "L'Inspection des camps de concentration ouvre le complexe de Buchenwald, près de la ville de Weimar, en Allemagne. Au moins 56 000 prisonniers y seront assassinés, dont environ 11 000 Juifs."},
      "media": {"url": "assets/images/prison1.webp", "caption": "Prisonniers fraîchement arrivés au camp de concentration de Buchenwald."}
    },
    {
      "start_date": {"year": 1937, "month": 11, "day": 26},
      "text": {"headline": "L'Italie rejoint l'Allemagne et le Japon.", "text": "L’Italie rejoint l’Allemagne et le Japon dans le pacte anti-Komintern."},
      "media": {"url": "assets/images/italietri.webp", "caption": "Réception au Palazzo Venezia de Rome, après que l’Italie a rejoint le pacte anti-Komintern germano-nippon"}
    },
    {
      "start_date": {"year": 1937, "month": 12, "day": 14},
      "text": {"headline": "Décret contre la criminalité", "text": "Heinrich Himmler, chef de la SS et de la police allemande, promulgue un décret sur la lutte préventive contre la criminalité par la police (Grunderlaß über vorbeugende Verbrechensbekämpfung durch die Polizei), qui autorise la police criminelle allemande à arrêter sans preuve les individus suspectés de comportements asociaux ou criminels, de les incarcérer pour une durée indéfinie, et de les envoyer en camp de concentration. Entre 1937 et 1943, ce sera le sort de plus de 70 000 « asociaux » et délinquants. Près de la moitié d'entre eux y périront."},
      "media": {"url": "assets/images/himmler.webp", "caption": "Portrait de Heinrich Himmler"}
    },




    {
      "start_date": {"year": 1938, "month": 3, "day": 11},
      "text": {"headline": "Anschluss", "text": "L'Allemagne proclame l'Anschluss : ses troupes envahissent l'Autriche et l'annexe au Reich. S'ensuit, au cours des mois suivants, une vague de violence contre les Juifs et leurs biens dans les rues de Vienne et d'autres villes du « Grand Reich », qui atteindra son paroxysme avec les émeutes de la Nuit de cristal (Kristallnacht), le 9 novembre."},
      "media": {"url": "assets/images/anschluss.webp", "caption": "Peu après l'Anschluss, des troupes d'assaut nazies montent la garde devant un magasin juif"}
    },
    {
      "start_date": {"year": 1938, "month": 4, "day": 26},
      "text": {"headline": "Déclaration des biens", "text": "Le gouvernement allemand exige que tous les Juifs déclarent leurs biens dès lors que leur valeur dépasse 5000 reichsmarks. Ceux-ci sont mis à disposition d'Hermann Goering, délégué au « Plan de quatre ans », pour « les besoins de l'économie allemande »."},
      "media": {"url": "assets/images/enregistrement.webp", "caption": "décret sur l'enregistrement des bien des Juifs"}
    },
    {
      "start_date": {"year": 1938, "month": 5, "day": 3},
      "text": {"headline": "Camp de concentration de Flossenbürg", "text": "Les autorités SS ouvrent le camp de concentration de Flossenbürg, au nord de la Bavière, en Allemagne."},
      "media": {"url": "assets/images/flossenburg.webp", "caption": "Plan du camp de concentration de Flossenbürg"}
    },
    {
      "start_date": {"year": 1938, "month": 6, "day": 13},
      "text": {"headline": "Opération contre les « réfractaires au travail »", "text": "La police criminelle allemande envoie dans les camps de concentration 9000 « asociaux » et délinquants récidivistes, dont plus d'un millier de Juifs, entre le 13 et le 18 juin."},
      "media": {"url": "assets/images/train1.webp", "caption": "Des milliers de juifs envoyés dans les camps de concentration"}
    },
    {
      "start_date": {"year": 1938, "month": 8, "day": 8},
      "text": {"headline": "Camp de concentration de Mauthausen", "text": "La SS ouvre le camp de concentration de Mauthausen, près de Linz, en Autriche. Entre avril et décembre 1940, plus de 6000 détenus venus de Mauthausen, Gusen et Dachau ont été tués à Hartheim. Au total, environ 30 000 personnes, prisonniers de camps de concentration et victimes des programmes « d'euthanasie » y ont perdu la vie."},
      "media": {"url": "assets/images/entrance.webp", "caption": "La place de l'appel, face à l'entrée principale"}
    },
    {
      "start_date": {"year": 1938, "month": 11, "day": 9},
      "text": {"headline": "Nuit de cristal", "text": "La nuit du 9 au 10 novembre, le Parti nazi organise un pogrom contre la population juive. Des synagogues sont incendiées, des foyers et des commerces pillés, et au moins 91 Juifs sont tués. Avec le concours de la police locale en uniforme, la Gestapo arrête 30 000 hommes puis les envoie dans les camps de concentration de Dachau, Sachsenhausen et Buchenwald."},
      "media": {"url": "assets/images/cristal.webp", "caption": "Une boutique appartenant à un juif est détruite au cours de la Nuit de Cristal"}
    },
    {
      "start_date": {"year": 1938, "month": 11, "day": 15},
      "text": {"headline": "Exclusion des Juifs des écoles", "text": "Les autorités allemandes interdisent que des enfants juifs fréquentent les écoles publiques. Ils ne peuvent être scolarisés que dans des établissements séparés, financés et gérés par la communauté juive."},
      "media": {"url": "assets/images/ecolejuive.webp", "caption": "Photo de classe d'une école juive"}
    },





    {
      "start_date": {"year": 1939, "month": 1, "day": 17},
      "text": {"headline": "Exclusion des Juifs des métiers scientifiques", "text": "Le gouvernement allemand interdit aux Juifs d'exercer les professions d'infirmier, de vétérinaire, de pharmacien et de dentiste."},
      "media": {"url": "assets/images/help.webp", "caption": "Pancarte utilisée lors du boycott antijuif : “Aidez à libérer l’Allemagne du capital juif. N’achetez pas dans les magasins juifs.”"}
    },
    {
      "start_date": {"year": 1939, "month": 5, "day": 15},
      "text": {"headline": "Camp de Ravensbrück", "text": "Les autorités SS mettent en place le plus vaste camp de concentration pour femmes à Ravensbrück, au nord de Berlin."},
      "media": {"url": "assets/images/planraven.webp", "caption": "Plan du camp de Ravensbrück"}
    },
    {
      "start_date": {"year": 1939, "month": 5, "day": 22},
      "text": {"headline": "Pacte d'acier", "text": "Lallemagne et l'Italie signent le Pacte d'acier, qui lie un contrat d'amitié et d'alliance entre les deux nations. C'est donc une alliance militaire et politique."},
      "media": {"url": "assets/images/acier.webp", "caption": "Signature du Pacte d'acier à la Chancellerie du Reich à Berlin"}
    },
    {
      "start_date": {"year": 1939, "month": 8, "day": 23},
      "text": {"headline": "Pacte de non-agression", "text": "L’Allemagne nazie et l'Union Soviétique signent un pacte de non-agression et un protocole secret qui partage l’Europe orientale en sphères d’influence."},
      "media": {"url": "assets/images/germanosovietique.webp", "caption": "Modifications territoriales prévues par le pacte et finalement effectuées"}
    },
    {
      "start_date": {"year": 1939, "month": 9, "day": 1},
      "text": {"headline": "Invasion de la Pologne", "text": "L'Allemagne envahit la Pologne, déclenchant la Seconde Guerre mondiale en Europe."},
      "media": {"url": "assets/images/poland.webp", "caption": "Bombardement de Varsovie"}
    },
    {
      "start_date": {"year": 1939, "month": 9, "day": 2},
      "text": {"headline": "Camp de Stutthof", "text": "Les autorités SS mettent en place le camp pour prisonniers civils de Stutthof, près de Dantzig (Gdansk). Le 7 janvier 1942, l'Inspection des camps de concentration le redéfinira comme camp de concentration."},
      "media": {"url": "assets/images/cartecamps.webp", "caption": "Principaux camps de concentration en Allemagne avec Stutthof indiqué en jaune"}
    },
    {
      "start_date": {"year": 1939, "month": 9, "day": 3},
      "text": {"headline": "Déclaration de Guerre", "text": "Honorant leur garantie des frontières de la Pologne, la Grande-Bretagne et la France déclarent la guerre à l’Allemagne."},
      "media": {"url": "assets/images/declarationguerref.webp", "caption": "Journal Paris-soir annonçant la déclaration de guerre de la France à l'Allemagne le 3 septembre 1939"}
    },
    {
      "start_date": {"year": 1939, "month": 11, "day": 23},
      "text": {"headline": "Port obligatoire du brassard", "text": "Les autorités allemandes imposent à tous les Juifs de plus de 10 ans résidant dans le Generalgouvernement le port d'un brassard blanc orné d'une étoile de David."},
      "media": {"url": "assets/images/brassard.webp", "caption": "Brassard blanc avec l'étoile de David en bleu"}
    },





    {
      "start_date": {"year": 1940, "month": 5, "day": 10},
      "text": {"headline": "Invasion de la France", "text": "Les forces allemandes envahissent les Pays-Bas, la Belgique, le Luxembourg et la France. Au 22 juin, elles auront occupé toutes ces régions, à l'exception du sud de la France, « la France de Vichy »."},
      "media": {"url": "assets/images/invasionfrance.webp", "caption": "Route suivie par les Allemands, entre le 10 et le 26 juin 1940 (carte espagnole)"}
    },
    {
      "start_date": {"year": 1940, "month": 5, "day": 20},
      "text": {"headline": "Camp de concentration d'Auschwitz I", "text": "Les autorités SS ouvrent le camp de concentration d'Auschwitz (Auschwitz I) près de la ville polonaise d'Oswiecim, dans la Haute-Silésie annexée par l'Allemagne."},
      "media": {"url": "assets/images/plana2.webp", "caption": "1. Maison du commandement de camp - 2. Maison du garde principal - 3. Bureau d'administration du camp - 4. Gestapo - 5. Accueil / enregistrement des prisonniers - 6. Cuisines - 7. Chambre à gaz et crematorium - 8. Stockage et ateliers - 9. Stockage des biens confisqués - 10. Carrières : site d'exécution - 11. Orchestre du camp - 12. Site d'exécution «  Mur noir  » - 13. Bunker de punition - 14. Expériences médicales - 15. Potence - 16 Caserne du commandement - 17. Hôpital SS"}
    },
    {
      "start_date": {"year": 1940, "month": 6, "day": 4},
      "text": {"headline": "Sous-camp Neuengamme", "text": "Après avoir ouvert Neuengamme, un sous-camp de Sachsenhausen, à la mi-décembre 1938 en banlieue de Hambourg, l'Inspection des camps de concentration le place directement sous son contrôle, en faisant un camp autonome."},
      "media": {"url": "assets/images/neuengamme.webp", "caption": "Vue aérienne du camp"}
    },
    {
      "start_date": {"year": 1940, "month": 6, "day": 10},
      "text": {"headline": "L'Italie entre en Guerre", "text": "L'Italie envahit le sud de la France le 21 juin."},
      "media": {"url": "assets/images/FranceOccupeeitalie.webp", "caption": "Carte de l'occupation en France. L'occupation italienne est représentée en vert."}
    },
    {
      "start_date": {"year": 1940, "month": 6, "day": 18},
      "text": {
        "headline": "Appel du 18 juin",
        "text": "Depuis Londres, le général de Gaulle appelle les Français à poursuivre le combat contre l'Allemagne nazie. Cet appel marque symboliquement le début de la France libre."
      },
      "media": {"url": "assets/images/aze_mlm1992.5_001.webp", "caption": "Portrait du général de brigade Charles de Gaulle"}
    },

    {
      "start_date": {"year": 1940, "month": 7},
      "text": {
        "headline": "Les premiers actes de Résistance",
        "text": "Dès l'été 1940, des citoyens isolés diffusent des tracts, recueillent des informations et refusent l’occupation. Ces gestes marquent les débuts de la Résistance intérieure."
      },
      "media": {"url": "assets/images/tratc_11_novembre.webp", "caption": "Copie d'un tract distribué aux étudiants pour la manifestation du 11 novembre 1940 et article paru dans Résistance-La Voix"}
    },
    {
      "start_date": {"year": 1940, "month": 9, "day": 20},
      "text": {"headline": "Camp de Breendonk", "text": "Les premiers prisonniers, notamment des Juifs apatrides, arrivent au camp de détention de Breendonk, en banlieue d'Anvers, en Belgique."},
      "media": {"url": "assets/images/breendonk.webp", "caption": "Entrée du camp de Breendonk"}
    },
    {
      "start_date": {"year": 1940, "month": 9, "day": 27},
      "text": {"headline": "Pacte Tripartite", "text": "L’Allemagne, l’Italie et le Japon signent le Pacte Tripartite."},
      "media": {"url": "assets/images/tripartite.webp", "caption": "Les 3 pays célèbrent le Pacte Tripartite"}
    },






    {
      "start_date": {"year": 1941, "month": 1},
      "text": {
        "headline": "Création des premiers réseaux organisés",
        "text": "Entre 1941 et 1942 naissent des réseaux structurés comme Combat, Libération-Sud, Franc-Tireur ou l’Organisation Civile et Militaire (OCM). Ils publient des journaux clandestins et transmettent des renseignements aux Alliés."
      },
      "media": {"url": "assets/images/Articles_ResisJournaux3MouvResis.webp", "caption": "Journaux des trois mouvements de résistance qui s'unirent pour former le Mouvement Unis de Résistance"}
    },
    {
      "start_date": {"year": 1941, "month": 1, "day": 15},
      "text": {"headline": "Solution finale", "text": "Reinhard Heydrich, chef de la RSHA, propose les grandes lignes d'un plan pour aboutir à une « solution finale » à la prétendue question juive dans l'Europe contrôlée par l'Allemagne."},
      "media": {"url": "assets/images/page3.webp", "caption": "Page 3 du mémorandum, mentionnant la « solution finale ». Traduction vers l'anglais par la librairie Truman."}
    },
    {
      "start_date": {"year": 1941, "month": 3, "day": 1},
      "text": {"headline": "Camp de Birkenau", "text": "Heinrich Himmler ordonne la construction d'un vaste camp pouvant contenir 100 000 prisonniers de guerre près du village de Birkenau (Brzezinka), à moins de deux kilomètres du camp de concentration d'Auschwitz."},
      "media": {"url": "assets/images/arriveea.webp", "caption": "Arrivée et tri sélectif des Juifs, venant d'arriver au camp'"}
    },
    {
      "start_date": {"year": 1941, "month": 3, "day": 15},
      "text": {"headline": "Camp de Beaune-la-Rolande", "text": "Dans la France occupée, les autorités allemandes ouvrent le camp d'internement de Beaune-la-Rolande. Y sont incarcérés des Juifs français et étrangers résidants en France. Plus tard, nombre d'entre eux seront transférés à Drancy avant d'être déportés au camp de concentration d'Auschwitz et au centre de mise à mort de Sobibor."},
      "media": {"url": "assets/images/beaune.webp", "caption": "Baraques du camp de Beaune-la-Rolande, en 1941"}
    },
    {
      "start_date": {"year": 1941, "month": 5, "day": 1},
      "text": {"headline": "Camp de Gross-Rosen", "text": "L'Inspection des camps de concentration déclare le camp de concentration de Gross-Rosen comme autonome, après l'avoir conçu comme un sous-camp de Sachsenhausen."},
      "media": {"url": "assets/images/grossrosen.webp", "caption": "Plan du camp"}
    },
    {
      "start_date": {"year": 1941, "month": 5, "day": 15},
      "text": {"headline": "Camp d'internement de Pithiviers'", "text": "Dans la France occupée, les autorités allemandes ouvrent le camp d'internement de Pithiviers, où ils emprisonnent les Juifs, Français et étrangers résidant en France. Pithiviers constituait souvent une étape avant le transfert vers Drancy, d'où les prisonniers étaient déportés vers le camp de concentration d'Auschwitz et le centre de mise à mort de Sobibor."},
      "media": {"url": "assets/images/pithiviers.webp", "caption": "Camp d'internement de Pithiviers, 1941"}
    },
    {
      "start_date": {"year": 1941, "month": 5, "day": 21},
      "text": {"headline": "Camp de Natzweiler-Struthof", "text": "L'Inspection des camps de concentration SS ouvre le camp de concentration de Natzweiler-Struthof près de Strasbourg, en France."},
      "media": {"url": "assets/images/natzweiler.webp", "caption": "L'entrée du camp"}
    },
    {
      "start_date": {"year": 1941, "month": 7, "day": 31},
      "text": {"headline": "Mise en oeuvre de la Solution Finale", "text": "Hermann Goering, maréchal du Reich, charge Reinhard Heydrich, chef du RSHA, de prendre des mesures pour la mise en œuvre d'une « solution finale à la question juive ». L'euphémisme est clair, il s'agit d'une extermination massive de la population juive d'Europe."},
      "media": {"url": "assets/images/lettresf.webp", "caption": "Lettre de Göring à Heydrich chargeant ce dernier d'organiser la « solution finale de la question juive »"}
    },
    {
      "start_date": {"year": 1941, "month": 8},
      "text": {"headline": "École juive pour Anne Frank", "text": "Anne et Margot Frank doivent quitter leur école pour aller à l'école juive d'Amsterdam."},
      "media": {"url": "assets/images/afamsterdam.webp", "caption": "Anne Frank sur son pupitre d'écolière à Amsterdam"}
    },
    {
      "start_date": {"year": 1941, "month": 8, "day": 24},
      "text": {"headline": "Mort par euthanasie", "text": "Adolf Hitler ordonne l'arrêt des meurtres par « euthanasie » généralisés. Le personnel sanitaire allemand a jusque-là éliminé environ 70 000 personnes dans des centres dédiés. Les exécutions d'enfants et d'adultes atteints d'un handicap mental ou physique se poursuivent tout de même. Les méthodes utilisées sont la privation de nourriture, l'injection mortelle et l'absence délibérée de traitement en cas de maladie grave."},
      "media": {"url": "assets/images/euthanasie.webp", "caption": "L'autorisation d'euuthanasie d'Adolf Hitler, 1939"}
    },
    {
      "start_date": {"year": 1941, "month": 8, "day": 28},
      "text": {"headline": "Camp de détention Royallieu", "text": "En France, les autorités allemandes ouvrent un camp de détention à Compiègne, qui servira de camp de transit pour les prisonniers déportés à Dachau ou Auschwitz."},
      "media": {"url": "assets/images/royallieu.webp", "caption": "Baraques du camp, de nos jours"}
    },
    {
      "start_date": {"year": 1941, "month": 9, "day": 1},
      "text": {"headline": "Étoile de David", "text": "Le ministre de l'Intérieur du Reich décrète que tout Juif de 6 ans et plus vivant dans le Grand Reich doit porter l'étoile jaune sur le vêtement extérieur lorsqu'il est en public."},
      "media": {"url": "assets/images/etoilej.webp", "caption": "Photo de classe. Tout le monde porte l'étoile jaune."}
    },
    {
      "start_date": {"year": 1941, "month": 9, "day": 3},
      "text": {"headline": "Gazage au Zyklon B", "text": "Au camp de concentration d'Auschwitz, les SS expérimentent le gazage au Zyklon B pour la première fois. Les victimes sont des prisonniers de guerre soviétiques."},
      "media": {"url": "assets/images/chambregaz.webp", "caption": "Chambre à gaz dans le camp principal d'Auschwitz"}
    },
    {
      "start_date": {"year": 1941, "month": 10, "day": 15},
      "text": {"headline": "Opération Reinhard", "text": "C'est l'annihilation physique des Juifs. Au total, environ 1,7 million d'entre eux, surtout des Polonais, seront exterminés dans le cadre de cette opération."},
      "media": {"url": "assets/images/reinhard.webp", "caption": "Reinhard Heydrich, chef de la SD (Service de sécurité) et gouverneur nazi de la Bohème et de la Moravie"}
    },
    {
      "start_date": {"year": 1941, "month": 10, "day": 20},
      "text": {"headline": "Camp de la Waffen-SS", "text": "Les premiers détenus arrivent au camp de la Waffen-SS en banlieue de la ville de Lublin, dans le Generalgouvernement, destiné aux prisonniers de guerre."},
      "media": {"url": "assets/images/WaffenSS.webp", "caption": "Casquette de sous-officier d'infanterie de la Waffen-SS"}
    },
    {
      "start_date": {"year": 1941, "month": 12},
      "text": {
        "headline": "Développement des réseaux spécialisés",
        "text": "Des groupes spécialisés apparaissent : le Réseau du Musée de l’Homme, tourné vers la diffusion d’informations, ou le Réseau Alliance, actif dans le renseignement militaire."
      },
      "media": {"url": "assets/images/aze_mlm2000.72_001.webp", "caption": "Portrait de Marie-Madeleine Fourcade"}
    },
    {
      "start_date": {"year": 1941, "month": 12, "day": 7},
      "text": {"headline": "Attaque de Pearl Harbor par le Japon", "text": "Les États-Unis entrent dans la Seconde Guerre Mondiale le lendemain, en déclarant la Guerre au Japon."},
      "media": {"url": "assets/images/pearlharbor.webp", "caption": "Vue aérienne de l'attaque de Pearl Harbor"}
    },
    {
      "start_date": {"year": 1941, "month": 12, "day": 8},
      "text": {"headline": "Camp de mise à mort de Chelmno", "text": "Les exécutions commencent au centre de mise à mort de Chelmno, en Pologne. Il sera actif jusqu'en mars 1943, puis brièvement en juin et début juillet 1944."},
      "media": {"url": "assets/images/chelmno.webp", "caption": "Plan général du centre d'extermination de Chelmno. Le nord est à gauche sur le croquis."}
    },






    {
      "start_date": {"year": 1942, "month": 1},
      "text": {
        "headline": "Arrivée de Jean Moulin en France",
        "text": "Mandaté par de Gaulle, Jean Moulin a pour mission d'unifier les mouvements de Résistance intérieure afin de renforcer leur efficacité."
      },
      "media": {"url": "assets/images/jean-moulin.webp", "caption": "Jean Moulin aux Arceaux près de la promenade du Peyrou à Montpellier"}
    },
    {
      "start_date": {"year": 1942, "month": 3, "day": 1},
      "text": {"headline": "Camp de concentration Auschwitz-Birkenau", "text": "Auschwitz II est construit près du premier camp. D'abord conçu pour y incarcérer des détenus soviétiques et polonais en masse, le complexe continue à fonctionner comme camp de concentration, mais sert également de centre de mise à mort entre mars 1942 et novembre 1944."},
      "media": {"url": "assets/images/campII.webp", "caption": "Plan du camp d'Auschwitz II"}
    },
    {
      "start_date": {"year": 1942, "month": 3, "day": 27},
      "text": {"headline": "Déportations des Juifs", "text": "Les autorités allemandes commencent les déportations systématiques de milliers de Juifs de France, en direction du centre de mise à mort d'Auschwitz-Birkenau. Entre mars et août 1944, ce sont plus de 75 000 Juifs qui seront déportés vers l'est. Moins de 3000 survivront."},
      "media": {"url": "assets/images/arriveea2.webp", "caption": "L'arrivée à Auschwitz-Birkenau"}
    },
    {
      "start_date": {"year": 1942, "month": 5, "day": 3},
      "text": {"headline": "Gazage des Juifs", "text": "Au centre de mise à mort d'Auschwitz-Birkenau, les fonctionnaires SS trient les victimes pour les envoyer dans les chambres à gaz. Un médecin SS trie les prisonniers faibles, malades, et « inaptes » placés en isolation, pour les emmener vers un bunker où ils sont assassinés au zyklon B (acide prussique). Entre mai 1940 et janvier 1945, les autorités du camp exterminent plus d'un million de personnes sur le complexe concentrationnaire. Parmi les prisonniers, 865 000, essentiellement des Juifs, ne seront pas enregistrés, très probablement gazés dès leur arrivée."},
      "media": {"url": "assets/images/gazageab.webp", "caption": "Des déportés Juifs dirigés vers la chambre à gaz, le 27 mai 1944"}
    },
    {
      "start_date": {"year": 1942, "month": 6, "day": 12},
      "text": {"headline": "Anniversaire de Anne Frank", "text": "Anne reçoit un journal intime pour son anniversaire et le nome « Kitty »."},
      "media": {"url": "assets/images/kitty.webp", "caption": "« Kitty », le journal intime d'Anne Frank"}
    },
    {
      "start_date": {"year": 1942, "month": 7, "day": 4},
      "text": {"headline": "Gazage systémique", "text": "Les autorités allemandes procèdent au gazage systématique des Juifs au centre de mise à mort d'Auschwitz."},
      "media": {"url": "assets/images/parcoursgaz.webp", "caption": "Le parcours des déportés vers la chambre à gaz"}
    },
    {
      "start_date": {"year": 1942, "month": 7, "day": 5},
      "text": {"headline": "Convocation de Margot", "text": "À Amsterdam, Margot Frank (soeur d'Anne) reçoit une convocation pour être déportée vers un camp de travail. Elle n'avait que 16 ans lors de sa convocation."},
      "media": {"url": "assets/images/margot.webp", "caption": "Margot Frank, sur son pupitre au lycée juif en 1941"}
    },
    {
      "start_date": {"year": 1942, "month": 7, "day": 6},
      "text": {"headline": "Anne Frank se cache", "text": "Anne Frank et sa famille se cachent à Amsterdam, au 263 Prinsengracht, pour échapper à la persécution nazie. Anne dit au revoir à son chat Moortje."},
      "media": {"url": "assets/images/cachette.webp", "caption": "La maison au 263, Prinsengracht où Anne Frank et sa famille se cachèrent. Amsterdam, Pays-Bas"}
    },
    




    {
      "start_date": {"year": 1943, "month": 1},
      "text": {
        "headline": "Création de l’Armée secrète",
        "text": "Les groupes paramilitaires des mouvements de Résistance sont réunis au sein de l’Armée secrète, future base des Forces françaises de l’intérieur."
      },
      "media": {"url": "assets/images/Insigne_Armée_secrète_Haute_savoie.webp", "caption": "Insigne Armée secrète Haute savoie"}
    },
    {
      "start_date": {"year": 1943, "month": 3, "day": 15},
      "text": {"headline": "Camp de Riga-Kaiserwald", "text": "L'Inspection des camps de concentration ouvre le camp de Riga-Kaiserwald, près de Riga, en Lettonie."},
      "media": {"url": "assets/images/riga.webp", "caption": "Baraques du camp de Riga-Kaiserwald"}
    },
    {
      "start_date": {"year": 1943, "month": 4, "day": 7},
      "text": {"headline": "Fermeture de Chelmno", "text": "La SS ferme le centre de mise à mort de Chelmno. Le détachement spécial Lange élimine toutes preuves de massacre sur le site et l'abandonne quatre jours plus tard."},
      "media": {"url": "assets/images/chelmnoferme.webp", "caption": "Localisation des camps d'extermination nazis"}
    },
    {
      "start_date": {"year": 1943, "month": 4, "day": 30},
      "text": {"headline": "Camp de Bergen-Belsen", "text": "Les autorités allemandes ouvrent un nouveau camp de concentration, où des dizaines de milliers de victimes, qui pourraient servir de monnaie d'échange aux Alliés, y seront rassemblées. Plus de 36 000 victimes, la majorité juive, y périront."},
      "media": {"url": "assets/images/bergen-belsen.webp", "caption": "Des prisonniers lors de la libération du camp"}
    },
    {
      "start_date": {"year": 1943, "month": 5, "day": 27},
      "text": {
        "headline": "Création du Conseil National de la Résistance",
        "text": "Jean Moulin parvient à réunir les principaux mouvements de Résistance au sein du CNR, une étape déterminante pour l’unification de la lutte clandestine."
      },
      "media": {"url": "assets/images/lpdp_36304-18.webp", "caption": "Membres du Conseil National de la Résistance (CNR) autour de son président Georges Bidault."}
    },
    {
      "start_date": {"year": 1943, "month": 6, "day": 21},
      "text": {
        "headline": "Arrestation de Jean Moulin",
        "text": "Jean Moulin est arrêté à Caluire-et-Cuire. Torturé par la Gestapo, il meurt en juillet 1943, devenant l’un des symboles les plus forts de la Résistance."
      },
      "media": {"url": "assets/images/Les_Clayes_sous_Bois_Monument_Jean_Moulin.webp", "caption": "Monument hommage à Jean Moulin, à Les Clayes Sous Bois (78)"}
    },
    {
      "start_date": {"year": 1943, "month": 9},
      "text": {
        "headline": "Organisation des maquis",
        "text": "Les maquis (Vercors, Glières, Mont Mouchet…) se structurent et accueillent notamment les réfractaires au STO. Ils mènent des opérations de guérilla et de sabotage."
      },
      "media": {"url": "assets/images/08-533499.webp", "caption": "Des maquisards près de Venelles à Sainte-Victoire"}
    },
    {
      "start_date": {"year": 1943, "month": 9, "day": 15},
      "text": {"headline": "Camp de Vaivara", "text": "L'Inspection des camps de concentration ouvre le camp de Vaivara, près de Reval, en Estonie."},
      "media": {"url": "assets/images/vaivara.webp", "caption": "Vue des baraques du camp de Vaivara"}
    },
    {
      "start_date": {"year": 1943, "month": 10, "day": 9},
      "text": {"headline": "Camp de La Risiera di San Sabba", "text": "Dans ce camp, les autorités ont à disposition des camions à gaz et un crématorium. Entre 3000 et 5000 personnes y sont assassinées."},
      "media": {"url": "assets/images/camiongaz.webp", "caption": "Un camion à gaz"}
    },
    {
      "start_date": {"year": 1943, "month": 10, "day": 14},
      "text": {"headline": "Révolte au camp de la mort Sobidor", "text": "Une révolte armée de 300 prisonniers parviennent à s'échapper, mais une centaine d'entre eux sont repris puis exterminés. Après cela, la SS ordonne le démantèlement des lieux."},
      "media": {"url": "assets/images/revolte.webp", "caption": "Portrait de groupe de quelques-uns des participants au soulèvement du camp d’extermination de Sobibor."}
    },
    {
      "start_date": {"year": 1943, "month": 12, "day": 2},
      "text": {"headline": "Camp de Buna", "text": "L'Inspection des camps de concentration renomme le sous-camp de Buna, à Auschwitz I, camp de concentration Auschwitz III, ou Monowitz."},
      "media": {"url": "assets/images/buna.webp", "caption": "Vue aérienne du camp de Buna, le 14 janvier 1945"}
    },





    {
      "start_date": {"year": 1944, "month": 3, "day": 15},
      "text": {
        "headline": "Publication du Programme du CNR",
        "text": "Le CNR adopte un programme politique et social prévoyant la démocratie restaurée, la sécurité sociale, le renforcement des droits sociaux et l’épuration des collaborateurs."
      },
      "media": {"url": "assets/images/Mav-Objet-JNR-26-05-2021.webp", "caption": "Le CNR annonce les Jours Heureux"}
    },
    {
      "start_date": {"year": 1944, "month": 6, "day": 6},
      "text": {"headline": "Débarquement en Normandie", "text": "Au moment du Débarquement en Normandie, la Résistance multiplie sabotages et transmissions de renseignements pour soutenir les opérations alliées. Les Alliés ouvrent un nouveau front en Europe."},
      "media": {"url": "assets/images/debarquement.webp", "caption": "Photographie des troupes américaines, le 6 juin 1944"}
    },
    {
      "start_date": {"year": 1944, "month": 6, "day": 18},
      "text": {"headline": "Horreurs au grand jour", "text": "Grâce aux médias suisses, le rapport rédigé par deux prisonniers juifs slovaques après leur évasion d'Auschwitz le 7 avril 1944 est rendu public dans le monde entier."},
      "media": {"url": "assets/images/selection.webp", "caption": "Sélection de femmes et enfants Juifs à la descente du train, Auschwitz-Birkenau, mai 1944"}
    },
    {
      "start_date": {"year": 1944, "month": 7, "day": 8},
      "text": {"headline": "Fermeture du camp de Kauen", "text": "Alors que l'armée soviétique approche, la SS liquide le camp de concentration de Kauen, près de la ville de Kaunas, et transfère environ 8000 Juifs aux camps de Stutthof et de Dachau."},
      "media": {"url": "assets/images/kauen.webp", "caption": "Liste des camps de concentration et d'extermination nazis"}
    },
    {
      "start_date": {"year": 1944, "month": 7, "day": 13},
      "text": {"headline": "Libération de Vilnius", "text": "L'armée soviétique libère Wilno (Vilnius), en Lituanie."},
      "media": {"url": "assets/images/vilnius2.webp", "caption": "L'armée soviétique libère Vilnius"}
    },
    {
      "start_date": {"year": 1944, "month": 7, "day": 23},
      "text": {"headline": "Libération du camp de Lublin", "text": "L'armée soviétique libère le camp de concentration de Lublin/Majdanek. Elle surprend la SS, qui avait évacué vers l'ouest les derniers prisonniers pour lui échapper, mais qui ne s'attendait pas à une avancée si rapide et n'a pas eu le temps de détruire le camp et les preuves de meurtres de masse."},
      "media": {"url": "assets/images/lublin.webp", "caption": "Vue aérienne du camp de concentration de Lublin/Majdanek"}
    },
    {
      "start_date": {"year": 1944, "month": 8, "day": 1},
      "text": {"headline": "Libération de Kaunas", "text": "L'armée soviétique libère la ville de Kaunas, en Lituanie."},
      "media": {"url": "assets/images/kaunasville.webp", "caption": "Les troupes soviétiques défilant dans les rues de Kaunas, après la libération"}
    },
    {
      "start_date": {"year": 1944, "month": 8, "day": 4},
      "text": {"headline": "Arrestation de la famille Frank", "text": "Anne Frank et sa famille, ainsi que les Van Pels et Pfeffer sont arrêtés à Amsterdam dans leur cachette par la Gestapo et emmenés dans un Commissariat de police d'Amsterdam."},
      "media": {"url": "assets/images/cachettearmoire.webp", "caption": "La bibliothèque cachant le passage secret menant au grenier où les familles se cachaient."}
    },
    {
      "start_date": {"year": 1944, "month": 8, "day": 6},
      "text": {"headline": "Évacuation des Juifs de Kaiserwald", "text": "La SS évacue les quelques Juifs encore à Kaiserwald vers Buchenwald et Dachau en passant par Stutthof."},
      "media": {"url": "assets/images/buchenwald.webp", "caption": "Vue aérienne du camp de Buchenwald, août 1944"}
    },
    {
      "start_date": {"year": 1944, "month": 8, "day": 8},
      "text": {"headline": "Anne Frank au camp de Westerbork", "text": "Anne Frank et sa famille sont transférés de la prison vers le camp de transit de Westerbork."},
      "media": {"url": "assets/images/garewesterbork.webp", "caption": "Gare ferroviaire du camp de Westerbork"}
    },
    {
      "start_date": {"year": 1944, "month": 8, "day": 25},
      "text": {
        "headline": "Libération de Paris",
        "text": "Paris est libéré grâce à l’action combinée des résistants, de la population parisienne et de la 2ᵉ DB du général Leclerc."
      },
      "media": {"url": "assets/images/aze_mlm2018.23.23_001.webp", "caption": "Portrait du général de brigade Charles de Gaulle lors du défilé sur les Champs-Elysées"}
    },
    {
      "start_date": {"year": 1944, "month": 9, "day": 5},
      "text": {"headline": "Anne Frank à Birkenau", "text": "La famille Frank est déportée de Westerbork au camp d'Auschwitz-Birkenau."},
      "media": {"url": "assets/images/trainaw.webp", "caption": "Plaque du train effectuant la navette Westerbork-Auschwitz"}
    },
    {
      "start_date": {"year": 1944, "month": 11, "day": 1},
      "text": {"headline": "Anne Frank à Bergen-Belsen", "text": "Anne Franck et sa soeur, Margot, sont transférées au camp de Bergen-Belsen."},
      "media": {"url": "assets/images/fourc.webp", "caption": "Four crématoire utilisé pendant la Guerre"}
    },
    {
      "start_date": {"year": 1944, "month": 11, "day": 23},
      "text": {"headline": "Libération de Natzweiler-Struthof", "text": "Les troupes américaines libèrent le camp de concentration de Natzweiler-Struthof."},
      "media": {"url": "assets/images/campns.webp", "caption": "Vue du camp après sa découverte en 1944"}
    },
    {
      "start_date": {"year": 1944, "month": 11, "day": 25},
      "text": {"headline": "Destruction de preuves", "text": "Sur les ordres de Heinrich Himmler, les autorités du camp d'Auschwitz détruisent les chambres à gaz et le crématorium d'Auschwitz-Birkenau."},
      "media": {"url": "assets/images/chambregaz.webp", "caption": "Chambre à gaz au camp d'Auschwitz-Birkenau "}
    },







    {
      "start_date": {"year": 1945, "month": 1, "day": 17},
      "text": {"headline": "Marche de la mort", "text": "À l'approche des troupes soviétiques, la SS commence à évacuer les prisonniers du complexe d'Auschwitz puis les oblige à marcher jusque vers l'intérieur du Reich."},
      "media": {"url": "assets/images/marchemort.webp", "caption": "Plan des différentes marches de la mort, depuis les différents camps"}
    },
    {
      "start_date": {"year": 1945, "month": 1, "day": 25},
      "text": {"headline": "Évacuation finale", "text": "La SS commence l'évacuation finale du camp de concentration de Stutthof."},
      "media": {"url": "assets/images/stutthof.webp", "caption": "Plan du camp de concentration de Stutthof, en automne 1944"}
    },
    {
      "start_date": {"year": 1945, "month": 1, "day": 27},
      "text": {"headline": "Libération d’Auschwitz", "text": "Les troupes soviétiques libèrent Auschwitz. Elles trouvent environ 7000 prisonniers abandonnés dans le camp principal et ses sous-camps."},
      "media": {"url": "assets/images/liberationa.webp", "caption": "Libération du camp"}
    },
    {
      "start_date": {"year": 1945, "month": 2, "day": 13},
      "text": {"headline": "Libération de Gross-Rosen", "text": "La 70e division d'infanterie motorisée de l'armée soviétique libère le camp de concentration de Gross-Rosen."},
      "media": {"url": "assets/images/mmgr.webp", "caption": "Marche de la mort depuis Gross-Rosen"}
    },
    {
      "start_date": {"year": 1945, "month": 3},
      "text": {"headline": "Décès d'Anne Frank", "text": "Anne Franck, âgée de 15 ans, et sa soeur Margot, 19 ans, meurent du typhus au camp de Bergen-Belsen."},
      "media": {"url": "assets/images/annefrank.webp", "caption": "Anne Frank en 1942, 2 mois avant qu'elle ne se cache avec sa famille."}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 4},
      "text": {"headline": "Libération d'Ohrdruf", "text": "La 4e division armée et la 89e division d'infanterie de la 3e armée américaine libèrent Ohrdruf, un sous-camp de Buchenwald. Une semaine plus tard, le général Dwight D. Eisenhower se rend sur les lieux et ordonne que les atrocités commises dans les camps de concentration nazis soient soigneusement documentées afin que personne ne puisse nier qu'elles aient existé."},
      "media": {"url": "assets/images/ohrdruf.webp", "caption": "Eisenhower (au centre), Commandeur suprême des Alliés, regarde les cadavres des prisonniers morts au camp de Ohrdruf."}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 11},
      "text": {"headline": "Libération de Mittelbau", "text": "Les troupes de la 3e division armée et de la 104e division d'infanterie américaines libèrent le camp de concentration de Mittelbau, à Nordhausen, en Allemagne. Ils y trouvent quelques survivants."},
      "media": {"url": "assets/images/doramittelbau.webp", "caption": "Après la libération de Dora-Mittelbau, les Allemands des alentours doivent enterrer les corps des victimes du camp"}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 12},
      "text": {"headline": "Libération de Westerbork", "text": "Les forces canadiennes libèrent environ 880 prisonniers au camp de Westerbork, aux Pays-Bas."},
      "media": {"url": "assets/images/westerbork-libre.webp", "caption": "Les dortoirs après la libération du camp"}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 15},
      "text": {"headline": "Libération de Bergen-Belsen", "text": "Le 63e régiment anti-char et la 11e division armée britanniques libèrent environ 60 000 prisonniers au camp de Bergen-Belsen. Anne Frank, alors âgée de 15 ans, meurt peu avant la libération du camp."},
      "media": {"url": "assets/images/bruler.webp", "caption": "Après la libération, le camp est entièrement brûlé pour empêcher la propagation du typhus"}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 20},
      "text": {"headline": "Évacuation de Sachsenhausen", "text": "La SS évacue les prisonniers du camp de concentration de Sachsenhausen et commence une marche forcée. Le 22 avril, les unités des 1re et 47e armées polonaises libèrent les quelque 3000 détenus encore dans le camp."},
      "media": {"url": "assets/images/marchemort.webp", "caption": "Plan des différentes marches de la mort, depuis les différents camps"}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 23},
      "text": {"headline": "Libération de Flossenbürg", "text": "La 90e division d'infanterie américaine libère le camp de concentration de Flossenbürg, en Allemagne."},
      "media": {"url": "assets/images/flossenburg2.webp", "caption": "Après la libération du camp de concentration de Flossenbürg, deux fantassins de l’armée américaine examinent une pile de chaussures"}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 28},
      "text": {"headline": "Derniers gazages du Reich", "text": "La SS assassine 33 membres d'organisations socialistes et communistes autrichiennes dans les chambres à gaz du camp de Mauthausen. C'est la dernière fois qu'une opération de gazage a lieu dans le Troisième Reich."},
      "media": {"url": "assets/images/mauthausentour.webp", "caption": "Le commandant du camp de concentration Franz Ziereis"}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 29},
      "text": {"headline": "Libération de Dachau", "text": "Les 42e et 45e divisions d'infanterie et la 20e division armée américaines libèrent environ 32 000 prisonniers à Dachau."},
      "media": {"url": "assets/images/dachaulibre.webp", "caption": "Vue de baraques après la libération de Kaufering, un sous-camp du réseau de camps de concentration de Dachau"}
    },
    {
      "start_date": {"year": 1945, "month": 4, "day": 30},
      "text": {"headline": "Suicide de Hitler", "text": "À Berlin, Hitler se suicide dans son bunker. De plus, les troupes soviétiques libèrent plus de 2000 prisonniers à Ravensbrück. En avril, avant qu'elles n'atteignent le camp, la SS en avait gazé entre 5000 et 6000."},
      "media": {"url": "assets/images/liberationr.webp", "caption": "Femmes de Ravensbrück attendant d'être évacuées par la Croix-Rouge suédoise. La croix blanche sur leur dos indique que ce sont des prisonnières condamnées à mort"}
    },
    {
      "start_date": {"year": 1945, "month": 5, "day": 4},
      "text": {"headline": "Libération de Neuengamme", "text": "Les forces britanniques libèrent le camp de concentration de Neuengamme, près de Hambourg."},
      "media": {"url": "assets/images/dortoirs.webp", "caption": "Dortoirs du camp de Neuengamme, après sa libération"}
    },
    {
      "start_date": {"year": 1945, "month": 5, "day": 5},
      "text": {"headline": "Libération de  Mauthausen et de Gusen", "text": "La 11e division armée américaine libère les prisonniers des camps de concentration de Mauthausen et de Gusen, sur les territoires autrichiens annexés du Reich."},
      "media": {"url": "assets/images/mauthausenaigle.webp", "caption": "Après la libération du camp de concentration de Mauthausen, des survivants acclament des soldats américains"}
    },
    {
      "start_date": {"year": 1945, "month": 5, "day": 8},
      "text": {"headline": "Fin de la guerre en Europe", "text": "Les forces allemandes signent l'acte de capitulation sans condition, à l'Ouest le 7 mai puis à l'Est le 9 mai. Les Alliés annoncent la victoire en Europe le 8 mai 1945 (en anglais « V-E Day »). Pour les forces soviétiques, le 9 mai est officiellement le dernier jour de la guerre."},
      "media": {"url": "assets/images/capitulation.webp", "caption": "Le maréchal Keitel signe l’acte de reddition de la Wehrmacht, le 8 mai 1945, à Berlin. - © Ministère des Armées"}
    },
    {
      "start_date": {"year": 1945, "month": 9, "day": 2},
      "text": {"headline": "Fin de la guerre dans le Pacifique", "text": "Le Japon capitule après les bombardements d'Hiroshima et Nagasaki. C'est officiellement la fin de la Seconde Guerre Mondiale."},
      "media": {"url": "assets/images/capitulationjaponaise.webp", "caption": "Mamoru Shigemitsu, le ministre des Affaires étrangères du Japon, signe les actes de capitulation du Japon sous le regard du général Richard K. Sutherland, le 2 septembre 1945."}
    },
    {
      "start_date": {"year": 1945, "month": 11, "day": 20},
      "text": {"headline": "Procès de 22 nazis", "text": "Le Tribunal militaire international, composé de juges américains, britanniques, français et soviétiques, entame le procès de 22 principaux responsables nazis à Nuremberg, en Allemagne."},
      "media": {"url": "assets/images/proces1.webp", "caption": "Vue d'ensemble du Tribunal"}
    },






    {
      "start_date": {"year": 1946, "month": 10, "day": 1},
      "text": {"headline": "Procès de Nuremberg", "text": "Le Tribunal militaire international rend son jugement sur les grands criminels de guerre nazis à Nuremberg, en Allemagne. Dix-huit d'entre eux sont reconnus coupables et trois autres acquittés. Onze des accusés sont condamnés à la peine de mort."},
      "media": {"url": "assets/images/proces.webp", "caption": "Vue partielle du banc des accusés"}
    },
    {
      "start_date": {"year": 1948},
      "text": {"headline": "Premières commémorations", "text": "Début des initiatives pour témoigner et éduquer sur la guerre et l’Holocauste."},
      "media": {"url": "assets/images/commemoration.webp", "caption": "Le 8 mai 1945, dans l’euphorie générale, les premiers défilés s’improvisent sur les Champs-Elysées"}
    }
  ]
};


var siTimeline = document.querySelector(".timelineBody");

if (siTimeline) {
  // Initialisation de TimelineJS
  var timeline = new TL.Timeline('timeline-embed', data, {
    language: 'fr',  // ou 'fr-FR' selon la version
    scale_factor: 6
  });

}

var siCredits = document.querySelector(".credits");

if (siCredits) {
  const btnSources = document.querySelector("#voirsources");
  const liste = document.querySelector(".liste");

  btnSources.addEventListener("click", () => {
    liste.classList.toggle("active");
    btnSources.textContent = liste.classList.contains("active")
      ? "Cacher les crédits"
      : "Voir tous les crédits";
  });


}



// nav ////////////////////////////////////////

const menuToggle = document.querySelector('.menu-toggle');
const menuLinks  = document.querySelectorAll('.menu__link');

menuToggle.addEventListener('click', menuOpen );

function menuOpen(){
    document.body.classList.toggle("menu--open");
}
menuLinks.forEach(link => {
  link.addEventListener('click', () => {
    document.body.classList.remove("menu--open");
  });
});


/////////////////////annee du footer
var actualyear = new Date().getFullYear();
var footerYear = document.querySelector(".footer__year");
footerYear.textContent = "© " + actualyear + " DUCARNE Julie";




